import tmgLogoUrl from '../../assets/tmg-logo.png'

export default {
  props: {
    isTransparent: {type: Boolean, default: false}
  },
  data: function () {
    return {
      tmgLogo: tmgLogoUrl
    }
  },
  computed: {
    componentClass: function () {
      return this.isTransparent ? 'header-transparent' : ''
    }
  },
  methods: {
    handleOnScroll: function () {
      if (window.scrollY > this.$el.offsetHeight) {
        this.$el.classList.toggle('sticky-header', true)
      } else {
        this.$el.classList.toggle('sticky-header', false)
      }
    },
    toggleMenu: function () {
      this.$el.parentNode.querySelector('.header').classList.toggle('show-on-mobile')
    },
    hideMenu: function () {
      this.$el.parentNode.querySelector('.header').classList.remove('show-on-mobile')
    }
  },
  mounted () {
    document.addEventListener('scroll', this.handleOnScroll)
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.handleOnScroll)
  }
}



// WEBPACK FOOTER //
// ./src/components/SiteHeader/SiteHeader.js